'use strict'
import angular from 'angular'

angular.module('tasksFilter').factory('TasksFilterDetailedOrdersOptionsProvider',
    function () {

        return {
            optionsForField: [
                {value: 'line_item_start', label: 'Line Item Start Date'},
                {value: 'line_item_end', label: 'Line Item End Date'},
                {value: 'flight_start', label: 'Flight Start Date'},
                {value: 'flight_end', label: 'Flight End Date'}
            ],

            optionsForComparator: [
                {value: 'e', label: '='},
                {value: 'g', label: '>'},
                {value: 'ge', label: '> or ='},
                {value: 'se', label: '< or ='},
                {value: 's', label: '<'}
            ],

            defaultValues(callback) {
                callback({})
            }
        }
    }
)
